import { useRecoilBridgeAcrossReactRoots_UNSTABLE } from 'recoil';

export let RecoilBridgeInner: ReturnType<typeof useRecoilBridgeAcrossReactRoots_UNSTABLE>;

export const RecoilBridgeCollector = () => {
  RecoilBridgeInner = useRecoilBridgeAcrossReactRoots_UNSTABLE();

  return null;
};
